import * as _ from "lodash";
import * as React from "react";
import {Dropdown} from "@bizform/primereact/components/dropdown/Dropdown";
import {MultiSelect} from "@bizform/primereact/components/multiselect/MultiSelect";
import {Button} from "@bizform/primereact/components/button/Button";
import {RadioButton} from "@bizform/primereact/components/radiobutton/RadioButton";
import {InputText} from "@bizform/primereact/components/inputtext/InputText";
import {AutoComplete} from "@bizform/primereact/components/autocomplete/AutoComplete";
import {
    GridIdKeyConstant,
    GridLinkIdKeyConstant
} from "@bizform/type/model/component_element/manifest_constant/Grid.constant";
import {FormField} from "@bizform/type/model/form/FormDataSchema.model";
import {
    FilterDataTypeMatchMode,
    FilterMatchMode,
    FilterType,
    FilterTypeDataType,
    FilterTypeMatchMode,
    GridRepeatedFiltersInformation
} from "@bizform/type/model/form/Grid.model";
import {LookUp} from "@bizform/type/model/data_type/LookUp.model";
import {GridFilters} from "@bizform/type/model/rest_api/Grid.model";
import {DataType} from "@bizform/type/model/model/DataType.model";
import {DomAttribute} from "@bizform/type/model/dom/DomAttribute.model";
import {AccessibilityDate, DomHelper, FunctionHelper, ObjectHelper} from "@bizform/helper/dist/js/bizflow/helper.min";
import {FormDataSchemaService, GridDataService, I18N, LookupService} from "@bizform/core/dist/js/bizflow/core.min";


type Props = {
    applicationId: string;
    formId: string;
    [GridIdKeyConstant]: string;
    [GridLinkIdKeyConstant]: string;
    containerElementId: string;
    forcedRerender: boolean;
    filter: Array<GridRepeatedFiltersInformation>;
    onSearch: (filters: Array<GridFilters>) => void;
    onFilterError?: (entityIdError: Array<string>) => void;
    inline?: boolean;
};

type State = {
    filters: Array<GridFilters>;
};

export class Filter extends React.Component<Props, State> {
    private _init: boolean;
    private _entity: {
        [key: string]: FormField;
    };
    private readonly _dOptions: {
        [type: string]: Array<LookUp>
    };
    private readonly _lookup: {
        [key: string]: boolean;
    };
    private readonly _col: any;
    private readonly _attr: any;
    private _forced: boolean;
    private _ref: HTMLElement;
    private _hasError: boolean;
    private _msgError: Array<string>;
    private _entityIdError: Array<string>;
    private _errorAttr = {
        [DomAttribute.VALIDATION]: ""
    };

    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this._col = "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 m-0 p-0";
        this._attr = {["bf-data-filter"]: ""};
        this._dOptions = {};
        this._lookup = {};
        this.state = {
            filters: []
        };
        this._filter = this._filter.bind(this);

        this._onSearch = this._onSearch.bind(this);
        this._onReset = this._onReset.bind(this);
        this._onClear = this._onClear.bind(this);
        this._onOptionsChange = this._onOptionsChange.bind(this);

        this._onDataChange = this._onDataChange.bind(this);
        this._onBlur = this._onBlur.bind(this);

        this._setRef = this._setRef.bind(this);
        this._keydown = this._keydown.bind(this);
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        if (this.props.forcedRerender || this._forced || (!this._init && this.props.applicationId && this.props.formId && this.props[GridIdKeyConstant] && this.props[GridLinkIdKeyConstant]) || ObjectHelper.hasDifference(this.state.filters, nextState.filters)) {
            this._init = true;
            this._forced = false;
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        if (this._ref) {
            this._ref.removeEventListener("keydown", this._keydown);
        }
    }

    render() {
        this._entity = FormDataSchemaService.getProjectDataSchemaData(this.props.applicationId, true).schema.entity;
        if (this.props.applicationId && this.props.formId && this.props[GridIdKeyConstant] && this.props[GridLinkIdKeyConstant] && this.props.filter && this.props.filter.length) {
            this._doValidation();
            const filter = this.props.filter.map(this._filter);
            const className = this._hasError ? "w-50 p-button-secondary" : "w-50 p-button-primary";
            return <div ref={this._setRef} className="row w-100 m-0 pt-0 pr-0 pb-1 pl-1 text-left">
                {filter}
                <div className={this._col}>
                    <div {...this._attr} className="h-100 m-0 pt-1 pr-1 pb-0 pl-0">
                        <div {...this._attr} className="m-0 p-1" style={{"backgroundColor": "rgba(0, 0, 0, 0.2)", "border": "1px solid rgba(0, 0, 0, 0.1)", "borderRadius": "0.2rem"}}>
                            <Button key={this.props.containerElementId + "_search"} label="Search" className={className} disabled={this._hasError} onClick={this._onSearch}/>
                            <Button key={this.props.containerElementId + "_reset"} label="Reset" className="w-50 p-button-secondary" onClick={this._onReset}/>
                        </div>
                    </div>
                </div>
            </div>;
        } else {
            return null;
        }
    }

    private _doValidation() {
        this._hasError = false;
        if (this._msgError) {
            delete (this._msgError);
            delete (this._entityIdError);
        }
        this._msgError = [];
        this._entityIdError = [];
        if (this.props.filter && this.props.filter.length) {
            for (let i = 0; i < this.props.filter.length; i++) {
                this._msgError[i] = "";
                this._entityIdError[i] = "";
                if (this.props.filter[i].filterFunc && this.state.filters[i]) {
                    const error: any = FunctionHelper.gridFilterExecute(this.props.filter[i].filterFunc, this.state.filters[i].matchMode, this.state.filters[i].value, this.state.filters[i].format);
                    if (error) {
                        this._hasError = true;
                        this._msgError[i] = error;
                        this._entityIdError[i] = this.props.filter[i].entityId;
                    }
                }
            }
        }
        if (this.props.onFilterError) {
            this.props.onFilterError(this._entityIdError);
        }
    }

    private _getFType(type: DataType): string {
        return FilterDataTypeMatchMode[type] ? type : FilterTypeDataType[type];
    }

    private _filter(filter: GridRepeatedFiltersInformation, index: number) {
        const e = this._entity[filter.entityId];
        if (!e || filter.type !== e.type) {
            return null;
        }
        const fType = this._getFType(e.type);
        switch (e.type) {
            case DataType.LOOKUP: case DataType.LOOKUPARRAY:
                if (!e.lookup || (!e.lookup.id && !e.lookup.parent)) {
                    return null;
                }
                if (e.lookup.parent) {
                    const pIndex = _.findIndex(this.props.filter, {entityId: e.lookup.parent});
                    if (pIndex === -1) {
                        return;
                    }
                    (filter as any).parent = pIndex;
                }
                break;
            case DataType.TIME: case DataType.DATETIME: case DataType.DATE: case DataType.DATEARRAY:
            case DataType.UTCTIME: case DataType.UTCDATETIME: case DataType.UTCDATE: case DataType.UTCDATEARRAY:
                if (!filter.format || !filter.format.input) {
                    return null;
                }
                break;
        }
        const options = this._options(fType, filter.entityId, this.props.filter[index].options);
        if (!options || !options.length) {
            return null;
        }
        const search = this._search(filter, this.state.filters[index], e.type, index);
        const className = "text-truncate bf-noBr" + (this.state.filters[index] && ((!Array.isArray(this.state.filters[index].value) && this.state.filters[index].value) || (Array.isArray(this.state.filters[index].value) && (this.state.filters[index].value[0] || this.state.filters[index].value[1]))) ? " bf-text-blue5" : "");
        const classSearch = this._hasError ? "w-50 p-button-secondary" : "w-50 p-button-primary";
        const validation = this._msgError[index] ? <div {...this._errorAttr}><span>{this._msgError[index]}</span></div> : null;
        return (
            <div className={this._col}>
                <div {...this._attr} bf-data-parent={filter.entityId} className="h-100 m-0 pt-1 pr-1 pb-0 pl-0">
                    <div {...this._attr} bf-data-value={filter.entityId} className="h-100 m-0 p-1" style={{
                        "backgroundColor": "rgba(255, 255, 255, 0.8)",
                        "border": "1px solid rgba(0, 0, 0, 0.3)",
                        "borderRadius": "0.2rem"
                    }}>
                        <div className={className} title={filter.label || e.label || e.name}>
                            {filter.label || e.label || e.name}
                            {validation}
                        </div>
                        <Dropdown
                            key={this.props.containerElementId + "_" + index}
                            value={this.state.filters[index] ? this.state.filters[index].matchMode : this._dOptions[filter.entityId][0].value}
                            options={options}
                            id={this.props.containerElementId + "-" + filter.entityId + "-" + index}
                            onChange={this._onOptionsChange}
                            disabled={options.length === 1}
                            className="mb-1"
                            style={{minWidth: "1rem"}}
                            appendTo={DomHelper.getForOverLayDom()}
                        />
                        {search}
                        {this.props.inline ?
                            <div className="pt-1 d-none" bf-data-button="">
                                <Button key={this.props.containerElementId + "_search" + "_" + index} label="Search"
                                        className={classSearch} disabled={this._hasError} onClick={this._onSearch}/>
                                <Button key={this.props.containerElementId + "_reset" + "_" + index}
                                        bf-data-value={index} label="Clear" className="w-50 p-button-secondary"
                                        onClick={this._onClear}/>
                            </div> : null
                        }
                    </div>
                </div>
            </div>
        );
    }

    private _options(type: string, entityId: string, pOptions: Array<string>): Array<LookUp> {
        if (!pOptions || !pOptions.length) {
            return [];
        }
        if (!this._dOptions[entityId]) {
            this._dOptions[entityId] = [];
            const options = FilterDataTypeMatchMode[type] || FilterTypeMatchMode[type];
            for (const key in options) {
                if (pOptions.indexOf(options[key]) > -1) {
                    this._dOptions[entityId].push({
                        label: I18N.translate(`{$I._app.grid.filter.${options[key]}}`), value: options[key]
                    });
                }
            }
        }
        return this._dOptions[entityId];
    }

    private _search(filter: GridRepeatedFiltersInformation, info: GridFilters, type: DataType, index: number) {
        // const fType = this._getFType(type);
        const key = this.props.containerElementId + "_s_" + index;
        const key2 = this.props.containerElementId + "_e_" + index;
        const id = this.props.containerElementId + "-" + filter.entityId + "-" + index + "-s";
        const id2 = this.props.containerElementId + "-" + filter.entityId + "-" + index + "-e";
        const e = this._entity[filter.entityId];
        const matchMode = info && info.matchMode ? info && info.matchMode : this._dOptions[filter.entityId][0].value;
        let value = info && Array.isArray(info.value) ? info.value[0] : (info && info.value ? info.value : null);
        let value2 = info && Array.isArray(info.value) ? info.value[1] : null;
        if (matchMode === FilterMatchMode.HASVALUE || type === DataType.BOOLEAN || type === DataType.TRISTATE) {
            const tri = (matchMode === FilterMatchMode.EQUALS || matchMode === FilterMatchMode.NOTEQUALS) && type === DataType.TRISTATE ? (
                <div className="pb-1">
                    <RadioButton
                        key={id + "n"}
                        id={id + "n"}
                        value="null"
                        checked={value === "null"}
                        onChange={this._onDataChange}
                    /> {I18N.translate("{$I._app.grid.filter.null}")}
                </div>
            ) : null;
            return <React.Fragment>
                <div className="pb-1">
                    <RadioButton
                        key={id + "t"}
                        id={id + "t"}
                        value="true"
                        checked={value === "true"}
                        onChange={this._onDataChange}
                    /> {I18N.translate(matchMode === FilterMatchMode.HASVALUE ? "{$I._app.grid.filter.hasValue}" : "{$I._app.grid.filter.true}")}
                </div>
                <div className="pb-1">
                    <RadioButton
                        key={id + "f"}
                        id={id + "f"}
                        value="false"
                        checked={value === "false"}
                        onChange={this._onDataChange}
                    /> {I18N.translate(matchMode === FilterMatchMode.HASVALUE ? "{$I._app.grid.filter.noValue}" : "{$I._app.grid.filter.false}")}
                </div>
                {tri}
                <div>
                    <RadioButton
                        key={id + "ok"}
                        id={id + "ok"}
                        checked={!value}
                        onChange={this._onDataChange}
                    /> {I18N.translate("{$I._app.grid.filter.noMatter}")}
                </div>
            </React.Fragment>;
        }
        switch (type) {
            case DataType.LOOKUP: case DataType.LOOKUPARRAY:
                if (matchMode === FilterMatchMode.EQUALS || matchMode === FilterMatchMode.NOTEQUALS || matchMode === FilterMatchMode.IN) {
                    const multiple = matchMode === FilterMatchMode.IN;
                    let lookupId;
                    let func = () => {
                        if (lookupId) {
                            this._lookup[lookupId] = true;
                            this._forced = true;
                            this.setState({
                                ...this.state
                            });
                        }
                        (func as any).__proto__ = null;
                        func = null;
                    };
                    if (e.lookup.id) {
                        lookupId = e.lookup.id;
                        if (!this._lookup[e.lookup.id]) {
                            LookupService.getEvaluatedLookupDataMap(this.props.applicationId, lookupId, null, null, e.lookup.lazy, func);
                        }
                    } else if (e.lookup.parent) {
                        const pIndex = (filter as any).parent;
                        if (this.state.filters[pIndex] && (this.state.filters[pIndex].matchMode === FilterMatchMode.EQUALS || this.state.filters[pIndex].matchMode === FilterMatchMode.NOTEQUALS) && this.state.filters[pIndex].value) {
                            lookupId = this._entity[this.props.filter[pIndex].entityId].lookup.id + "." + this.state.filters[pIndex].value;
                            if (!this._lookup[lookupId]) {
                                LookupService.getEvaluatedLookupDataMap(this.props.applicationId, lookupId, null, null, false, func);
                            }
                        }
                    }
                    if (e.lookup.id && e.lookup.lazy) {
                        const k = value ? LookupService.makeKey(id, value) : null;
                        const suggestions = k ? LookupService.getLookupDataMap(this.props.applicationId, e.lookup.id, value) : [];
                        return <AutoComplete
                            key={key}
                            inputId={id}
                            delay={300}
                            field={"label"}
                            multiple={multiple}
                            value={value}
                            suggestions={suggestions}
                            onBlur={this._onBlur}
                            onSelect={(r: any) => { this._onDataChange(r, filter.entityId, index); }}
                            completeMethod={(r: any) => { this._filterItem(e.lookup.id, r.query, index, matchMode); }}
                            appendTo={DomHelper.getForOverLayDom()}
                            placeholder={filter.placeholder}
                        />;
                    } else {
                        const options = lookupId && this._lookup[lookupId] ? LookupService.getLookupDataMap(this.props.applicationId, lookupId) : null;
                        if (multiple) {
                            return <MultiSelect
                                key={key}
                                id={id}
                                options={options}
                                value={value}
                                style={{width: "100%", maxWidth: "100%"}}
                                appendTo={DomHelper.getForOverLayDom()}
                                disabled={options === null || !options.length ? true : false}
                                onChange={this._onDataChange}
                                placeholder={filter.placeholder}
                                filter={true}
                            />;
                        } else {
                            return <Dropdown
                                key={key}
                                id={id}
                                options={options}
                                value={value}
                                style={{minWidth: "1rem"}}
                                appendTo={DomHelper.getForOverLayDom()}
                                disabled={options === null || !options.length ? true : false}
                                onChange={this._onDataChange}
                                placeholder={filter.placeholder}
                                showClear={true}
                                filter={true}
                            />;
                        }
                    }
                }
                break;
            case DataType.TIME: case DataType.DATETIME: case DataType.DATE: case DataType.DATEARRAY:
            case DataType.UTCTIME: case DataType.UTCDATETIME: case DataType.UTCDATE: case DataType.UTCDATEARRAY:
                const isDateTime = type === DataType.UTCTIME || type === DataType.UTCDATETIME;
                if (value && value.toString().startsWith("1000")) {
                    value = null;
                }
                if (matchMode === FilterMatchMode.BETWEEN) {
                    if (value2 && value2.toString().startsWith("9999")) {
                        value2 = null;
                    }
                    const placeholder = value ? <div className="float-right">({filter.format.input})</div> : null;
                    const placeholder2 = value2 ? <div className="float-right">({filter.format.input})</div> : null;
                    return <React.Fragment>
                        from{placeholder}
                        <AccessibilityDate
                            key={key}
                            id={id}
                            onChange={this._onDataChange}
                            simpleDateFormat={filter.format}
                            placeholder={filter.format.input}
                            today={false}
                            value={value}
                        />
                        to{placeholder2}
                        <AccessibilityDate
                            key={key2}
                            id={id2}
                            onChange={this._onDataChange}
                            simpleDateFormat={filter.format}
                            placeholder={filter.format.input}
                            today={false}
                            value={value2}
                        />
                    </React.Fragment>;
                } else {
                    const placeholder = value ? <div className="text-right">({filter.format.input})</div> : null;
                    return <React.Fragment>
                        {placeholder}
                        <AccessibilityDate
                            key={key}
                            id={id}
                            onChange={this._onDataChange}
                            simpleDateFormat={filter.format}
                            placeholder={filter.format.input}
                            today={false}
                            value={value}
                            isDateTime={isDateTime}
                        />
                    </React.Fragment>;
                }
            case DataType.NUMBER: case DataType.NUMBERARRAY: case DataType.INTEGER: case DataType.INTEGERARRAY:
                if (matchMode === FilterMatchMode.BETWEEN) {
                    return <React.Fragment>
                        from
                        <InputText
                            key={key}
                            id={id}
                            value={value ? value : ""}
                            onChange={this._onDataChange}
                            placeholder={filter.placeholder}
                        />
                        to
                        <InputText
                            key={key2}
                            id={id2}
                            value={value2 ? value2 : ""}
                            onChange={this._onDataChange}
                            placeholder={filter.placeholder}
                        />
                    </React.Fragment>;
                }
        }
        return <InputText
            key={key}
            id={id}
            value={value ? value : ""}
            onChange={this._onDataChange}
            placeholder={filter.placeholder}
        />;
    }

    private _onOptionsChange(e: {originalEvent: Event, value: any}) {
        const [, entityId, index] = (e as any).target.id.split("-");
        const filters = ObjectHelper.jsonCloneDeep(this.state.filters);
        const type = FilterTypeDataType[this._entity[entityId].type];
        let value = filters[index] && filters[index].value ? filters[index].value : null;
        const matchMode = this.state.filters[index] ? this.state.filters[index].matchMode : null;
        if (matchMode !== e.value) {
            if (matchMode) {
                if (e.value === FilterMatchMode.HASVALUE || matchMode === FilterMatchMode.HASVALUE) {
                    value = null;
                } else if (type === FilterType.LOOKUP || type === FilterType.LOOKUPARRAY) {
                    if (e.value === FilterMatchMode.EQUALS || e.value === FilterMatchMode.NOTEQUALS || matchMode === FilterMatchMode.EQUALS || matchMode === FilterMatchMode.NOTEQUALS) {
                        value = null;
                    }
                } else if (e.value === FilterMatchMode.BETWEEN) {
                    value = null;
                } else {
                    switch (matchMode) {
                        case FilterMatchMode.BETWEEN:
                            value = null;
                            break;
                    }
                }
            }
            filters[index] = {
                field: entityId,
                matchMode: e.value,
                type: type,
                value: value
            };
            if (this.props.filter[index] && this.props.filter[index].format) {
                filters[index].format = this.props.filter[index].format.input;
            }
            this.setState({
                ...this.state,
                filters: filters
            });
        }
    }

    private _onDataChange?(e: any, entityId?: string, index?: number) {
        let value;
        let arrIdx;
        if (!entityId) {
            const id = e.target && e.target.id ? e.target.id : e.id;
            [, entityId, index, arrIdx] = id.split("-");
            value = e.value || (e.target ? e.target.value : undefined);
        } else {
            value = e.value && e.value.value ? e.value : undefined;
        }
        const filters = ObjectHelper.jsonCloneDeep(this.state.filters);
        filters[index] = {
            field: entityId,
            matchMode: filters[index] && filters[index].matchMode ? filters[index].matchMode : this._dOptions[entityId][0].value,
            type: FilterTypeDataType[this._entity[entityId].type],
            value: filters[index] && filters[index].value ? filters[index].value : null
        };
        if (this.props.filter[index] && this.props.filter[index].format) {
            filters[index].format = this.props.filter[index].format.input;
        }
        if (arrIdx && arrIdx.length === 1) {
            if (!filters[index].value || !Array.isArray(filters[index].value)) {
                filters[index].value = [];
            }
            filters[index].value[arrIdx === "s" ? 0 : 1] = value;
        } else {
            filters[index].value = value;
        }
        this.setState({
            ...this.state,
            filters: filters
        });
    }

    private async _onBlur?(e: any): Promise<void> {
        const [, , index] = (e as any).target.id.split("-");
        await FunctionHelper.timeout(300);
        const filters = ObjectHelper.jsonCloneDeep(this.state.filters);
        if (filters[index] && filters[index].value && !filters[index].value.value) {
            filters[index].value = null;
            this.setState({
                ...this.state,
                filters: filters
            });
        }
    }

    private _onSearch() {
        if (!this._hasError) {
            const rFilters = GridDataService.makeFilter(this.props.applicationId, this.state.filters);
            this.props.onSearch(rFilters);
        }
    }

    private _onReset() {
        const filters = ObjectHelper.jsonCloneDeep(this.state.filters);
        if (Array.isArray(filters)) {
            for (const key in filters) {
                if (filters[key] && filters[key].value) {
                    delete (filters[key].value);
                }
            }
            this._forced = true;
            this.setState({
                ...this.state,
                filters: filters
            }, this._onSearch);
        }
    }

    private _onClear(e: any) {
        const filters = ObjectHelper.jsonCloneDeep(this.state.filters);
        if (Array.isArray(filters)) {
            const index = e.target.getAttribute("bf-data-value") || e.target.parentElement.getAttribute("bf-data-value");
            if (filters && filters[index] && filters[index].value) {
                delete (filters[index].value);
                this._forced = true;
                this.setState({
                    ...this.state,
                    filters: filters
                }, this._onSearch);
            }
        }
    }

    private _filterItem(id: string, query: string, index: number, matchMode: FilterMatchMode) {
        let func = () => {
            this._forced = true;
            const filters = ObjectHelper.jsonCloneDeep(this.state.filters);
            if (!filters[index]) {
                filters[index] = {
                    matchMode: matchMode,
                    value: query
                };
            } else {
                filters[index].value = query;
            }
            this.setState({
                ...this.state,
                filters: filters
            });
            (func as any).__proto__ = null;
            func = null;
        };
        LookupService.getEvaluatedLookupDataMap(this.props.applicationId, id, query, null, true, func);
    }

    private _keydown(e: any) {
        if (e && e.key === "Enter") {
            this._onSearch();
        }
    }

    private _setRef(ref: any) {
        if (this._ref) {
            this._ref.removeEventListener("keydown", this._keydown);
        }
        if (ref) {
            this._ref = ref;
            this._ref.addEventListener("keydown", this._keydown);
        }
    }
}
